export default "__VITE_ASSET__95f92c5e__"